import React from 'react';

import {NO_DATA_AVAILABLE} from 'src/constants';
import {EventReviewFeedback} from 'src/modules/ai';
import {HighlighterWrapper} from 'src/modules/event-review/highlighter/highlighter-wrapper';
import {HighlightFields} from 'src/modules/event-review/typedefs';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';
import {EventDetailInfo} from 'src/openapi/models/EventDetailInfo';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group, Item} from '@pb/kit-component-group';

type Props = {
    changeRequest: ChangeRequest,
    eventCodeInfo: EventDetailInfo | null,
    highlightsInfo: Record<HighlightFields, boolean> | null,
};

export const Families = (props: Props) => {
    const {
        changeRequest,
        eventCodeInfo,
        highlightsInfo,
    } = props;

    return (
        <Group direction="v" gap="xxs" justify="space-between">
            <Group>
                <strong>Families:</strong>
                <EventReviewFeedback changeRequestId={changeRequest.id} fieldName={HighlightFields.families}/>
            </Group>
            <Item style={{minWidth: 0}}>
                <HighlighterWrapper
                    actualValue={eventCodeInfo?.families.join(', ') || ''}
                    changeRequestValue={changeRequest.event.families.join(', ')}
                    highlight={!!highlightsInfo?.[HighlightFields.families]}>
                    <EllipsisTextHint>
                        <span>
                            {changeRequest.event.families.join(', ') || NO_DATA_AVAILABLE}
                        </span>
                    </EllipsisTextHint>
                </HighlighterWrapper>
            </Item>
        </Group>
    );
};
